import * as Actions from '../actions/profile.actions';
import { BusinessData } from '@app/api/models/api-models';

export interface ProfileState {
  isLoading: boolean;
  business: BusinessData[];
  errorMessage: string | string[];
  updateSucess: boolean;
  errorUpdating: boolean;
}

export const initialState: ProfileState = {
  isLoading: false,
  business: [],
  errorMessage: null,
  updateSucess: false,
  errorUpdating: false,
};

export function profileReducer(state: ProfileState = initialState, action: Actions.ProfileActions): ProfileState {
  switch (action.type) {
    case Actions.ActionTypes.UPDATE_BUSINESS_ATTEMPT: {
      return { ...state, updateSucess: false, errorUpdating: false };
    }

    case Actions.ActionTypes.UPDATE_BUSINESS_SUCCESS: {
      return { ...state, updateSucess: true, errorUpdating: false };
    }

    case Actions.ActionTypes.UPDATE_BUSINESS_FAILURE: {
      return {
        ...state,
        errorUpdating: true,
        errorMessage: action.payload.error,
      };
    }

    case Actions.ActionTypes.VALIDATE_ADDRESS_FAILURE: {
      return {
        ...state,
        errorUpdating: true,
        errorMessage: action.payload.error,
      };
    }
    case Actions.ActionTypes.ERROR_LAYOUT_SHOW: {
      return {
        ...state,
        // errorMessage: action.payload.payload.error ? action.payload.payload.error._body : '',
        isLoading: false,
      };
    }

    case Actions.ActionTypes.ERROR_LAYOUT_HIDE: {
      return { ...state, errorMessage: '', updateSucess: false, errorUpdating: false };
    }

    default:
      return state;
  }
}
